export const CSRF_KEY = 'CSRF_KEY'
export const APP_NAME = 'TOLL_ROADS'
